/** Имена полей-ссылок, найденные в данных справочника (`animalCategory`, `greenhouseCrop`, ...). */
export type RefFieldKeys = {
  category?: string | null;
  type?: string | null;
  crop?: string | null;
  bank?: string | null;
  unitMeasurement?: string | null;
};

/**
 * Ссылка приходит либо вложенным объектом (`animalCategory.id`),
 * либо плоским идентификатором (`animalCategoryId`). Ноль — валидный id.
 */
const refId = (fieldKey: string | null | undefined, initial: any) =>
  (fieldKey && initial?.[fieldKey]?.id) ??
  (fieldKey ? initial?.[`${fieldKey}Id`] : undefined);

/** Коды сервисов приходят либо списком объектов `services`, либо готовым `serviceCodes`. */
const initialServiceCodes = (initial: any): string[] => {
  if (Array.isArray(initial?.services)) {
    return initial.services
      .map((s: any) => s?.code)
      .filter((c: any) => typeof c === "string");
  }
  if (Array.isArray(initial?.serviceCodes)) return initial.serviceCodes;
  return [];
};

/** Раскладывает запись справочника в значения полей формы. */
export function buildInitialValues(
  initial: any,
  fieldKeys: RefFieldKeys,
): Record<string, unknown> {
  const region = initial.region ?? null;

  return {
    regionId: initial?.regionId ?? initial?.regionId?.id ?? null,
    code: initial.code ?? "",
    nameRu: initial.nameRu ?? "",
    nameKy: initial.nameKy ?? "",
    alias: initial.alias ?? "",
    bik: initial.bik ?? "",
    bankId: refId(fieldKeys.bank, initial) ?? null,
    division: initial.division ?? "",
    dataSourceStatus: initial.dataSourceStatus ?? "",
    serviceCodes: initialServiceCodes(initial),
    categoryId: refId(fieldKeys.category, initial),
    typeId: refId(fieldKeys.type, initial),
    type: initial.type ?? null,
    unitMeasurementId: refId(fieldKeys.unitMeasurement, initial),
    order: initial.order ?? null,
    thresholdPerM2: initial.thresholdPerM2 ?? null,
    cropId: refId(fieldKeys.crop, initial),
    region: region?.id ?? initial.regionId ?? null,
    descriptionRu: initial.descriptionRu ?? "",
    descriptionKy: initial.descriptionKy ?? "",
    address: initial.address ?? "",
  };
}
